import { useJsApiLoader } from '@react-google-maps/api';
import { createContext, useContext } from 'react';

const GOOGLE_MAP_LIBRARIES: ['places', 'visualization', 'marker'] = [
  'places',
  'visualization',
  'marker',
];

type MapsProviderContextType = {
  isLoaded: boolean;
  loadError: Error | undefined;
};

const MapsProviderContext = createContext<MapsProviderContextType | null>(null);

export const useMapsProvider = () => {
  const context = useContext(MapsProviderContext);
  if (!context) {
    throw new Error('useMapsProvider must be used within MapsProvider');
  }
  return context;
};

export type MapsProviderProps = {
  token: string;
  mapId?: string | null;
  children: React.ReactNode;
};

export const MapsProvider = ({ token, mapId, children }: MapsProviderProps) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: token,
    libraries: GOOGLE_MAP_LIBRARIES,
    mapIds: (mapId && [mapId]) || undefined,
  });

  return (
    <MapsProviderContext.Provider value={{ isLoaded, loadError }}>
      {children}
    </MapsProviderContext.Provider>
  );
};
